import { useForm } from 'react-hook-form';
import {
  Organization,
  UpdateOrganization,
  updateOrganizationSchema,
} from '@tinct/core-api-models';
import { zodResolver } from '@hookform/resolvers/zod';
import { useUpdateOrganization } from '@tinct/core-api';
import { handleApiError } from '@tinct/web-form';
import { toast } from 'sonner';

type UseUpdateOrganizationFormOptions = {
  organization: Organization;
  onSuccess?: () => void;
};

export const useUpdateOrganizationForm = ({
  organization,
  onSuccess,
}: UseUpdateOrganizationFormOptions) => {
  const form = useForm<UpdateOrganization>({
    resolver: zodResolver(updateOrganizationSchema),
    defaultValues: {
      name: organization.name ?? '',
    },
  });

  const updateOrganization = useUpdateOrganization({
    onSuccess: () => {
      toast.success('Workspace renamed successfully');
      onSuccess?.();
    },
    onError: (error) => handleApiError(error, form),
  });

  const handleSubmit = form.handleSubmit((data) => {
    if (!organization.id) return;
    updateOrganization.mutate({
      organizationId: organization.id,
      data,
    });
  });

  return { form, handleSubmit, isLoading: updateOrganization.isPending };
};
